import {
  BookmarkIcon,
  ChatBubbleOvalLeftEllipsisIcon,
  HeartIcon,
  PaperAirplaneIcon,
} from "@heroicons/react/24/outline";
import { HeartIcon as HeartSolidIcon } from "@heroicons/react/24/solid";
import React, { useContext, useState } from "react";
import Stories from "../components/Stories";
import { portfolioConfig } from "../config/portfolio.config";
import { ThemeContext } from "../contexts/ThemeContext";

const Home = () => {
  const [posts, setPosts] = useState(portfolioConfig.posts);
  const { darkMode } = useContext(ThemeContext);
  const [visibleComments, setVisibleComments] = useState({});

  const handleLike = (postId) => {
    setPosts(
      posts.map((post) =>
        post.id === postId
          ? { ...post, likes: post.likes + 1, isLiked: true }
          : post
      )
    );
  };

  const handleUnlike = (postId) => {
    setPosts(
      posts.map((post) =>
        post.id === postId
          ? { ...post, likes: post.likes - 1, isLiked: false }
          : post
      )
    );
  };

  const toggleComments = (postId) => {
    setVisibleComments((prev) => ({
      ...prev,
      [postId]: !prev[postId],
    }));
  };

  return (
    <div
      className={`${
        darkMode ? "bg-transparent text-white" : "bg-transparent text-black"
      } max-w-md mx-auto px-4`}
    >
      <Stories />
      {/* Stories section remains the same */}

      {/* Posts */}
      {posts.map((post) => (
        <div
          key={post.id}
          className={`mb-4 ${
            darkMode ? "bg-gray-900 text-white" : "bg-white"
          } mb-6 rounded-lg shadow`}
        >
          <div className="flex items-center p-4">
            <img
              src={portfolioConfig.avatar}
              alt={portfolioConfig.name}
              className="w-8 h-8 mr-3 rounded-full"
            />
            <span className="font-semibold">{portfolioConfig.username}</span>
          </div>

          <img src={post.image} alt={post.caption} className="w-full" />

          <div className="flex items-center justify-between px-4 py-2">
            <div className="flex space-x-4">
              {post.isLiked ? (
                <HeartSolidIcon
                  className="w-6 h-6 text-red-500 cursor-pointer"
                  onClick={() => handleUnlike(post.id)}
                />
              ) : (
                <HeartIcon
                  className="w-6 h-6 cursor-pointer"
                  onClick={() => handleLike(post.id)}
                />
              )}
              <ChatBubbleOvalLeftEllipsisIcon className="w-6 h-6 cursor-pointer" />
              <PaperAirplaneIcon className="w-6 h-6 cursor-pointer" />
            </div>
            <BookmarkIcon className="w-6 h-6 cursor-pointer" />
          </div>

          {/* Likes */}
          <div className="px-4 py-2">
            <p className="font-semibold">{post.likes} likes</p>
          </div>

          {/* Caption */}
          <div className="px-4 py-2">
            <p>
              <span className="mr-2 font-semibold">
                {portfolioConfig.username}
              </span>
              {post.caption}
            </p>
          </div>

          {/* Comments */}
          <div className="px-4 py-2">
            {visibleComments[post.id] ? (
              <>
                {post.comments.map((comment, index) => (
                  <p key={index} className="mb-1">
                    <span className="mr-2 font-semibold">{comment.user}</span>
                    {comment.text}
                  </p>
                ))}
                <button
                  className="mt-2 text-sm text-gray-500"
                  onClick={() => toggleComments(post.id)}
                >
                  Hide comments
                </button>
              </>
            ) : (
              <button
                className="text-sm text-gray-500"
                onClick={() => toggleComments(post.id)}
              >
                View all {post.comments.length} comments
              </button>
            )}
          </div>

          {/* Add comment */}
          <div className="flex items-center px-4 py-2 border-t dark:border-0">
            <input
              type="text"
              placeholder="Add a comment..."
              className={`flex-grow outline-none bg-transparent py-2 rounded-lg`}
            />
            <button className="font-semibold text-blue-500">Post</button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Home;
